/**
 * Whether to show the credential popup after account creation.
 * Only when welcome email delivery failed.
 */
export function shouldShowAccountSetupDialog(setup) {
  if (!setup) return false;
  return Boolean(setup.emailError);
}

export function accountSetupSuccessMessage(setup) {
  if (setup?.emailError) {
    return 'Account created, but the welcome email could not be sent. Copy credentials from the dialog.';
  }
  if (setup?.welcomeEmailSent) {
    return 'Account created. A welcome email with the password setup link was sent.';
  }
  return 'Account created successfully.';
}

export function accountResendWelcomeMessage(setup) {
  if (setup?.emailError) {
    return 'Welcome email could not be sent. Copy the new credentials from the dialog.';
  }
  if (setup?.welcomeEmailSent) {
    return 'Welcome email resent with a new temporary password.';
  }
  return 'New temporary password generated.';
}

/** User-facing post-create instructions when email delivery failed. */
export function getAccountSetupInstructions(setup) {
  if (!setup) return '';
  if (setup.emailError) {
    return `Welcome email could not be sent (${setup.emailError}). Share these credentials manually.`;
  }
  return 'Share these credentials with the user. They can sign in using the login link below.';
}
